export const SELECT_TAB = 'SELECT_TAB';
export const GET_TABS = 'GET_TABS';


// WEBPACK FOOTER //
// ./src/tabs/TabsActionTypes.js